module.exports = __webpack_public_path__ + "static/media/Multithreaded_Webserver.a682eb47.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/projects/Multithreaded_Webserver.pdf
// module id = 349
// module chunks = 0